import { Component } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { User } from 'src/app/auth/user.model';

interface MenuNode {
  name: string;
  children?: MenuNode[];
  icon?: string;
  link?: string;
  opened?: boolean;
  active?: boolean;
  raw?: string;
}

@Component({
  selector: 'atm-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss'],
})
export class MainMenuComponent {
  user!: User;
  rawMenuItemsList: MenuNode[] = [
    {
      name: 'References',
      opened: false,
      active: false,
      children: [
        {
          name: 'Countries',
          icon: 'language',
          link: 'countries',
          raw: 'countries',
        },
        { name: 'Firms', icon: 'business', link: 'firms', raw: 'firms' },
        {
          name: 'MNO',
          icon: 'network_cell',
          link: 'mnos',
          raw: 'mobilenetworkoperators',
        },
        {
          name: 'ISP',
          icon: 'wifi',
          link: 'isps',
          raw: 'internetserviceproviders',
        },
        {
          name: 'Payment Method',
          icon: 'paid',
          link: 'paymentmethods',
          raw: 'paymentmethods',
        },
        {
          name: 'Jobs IP Ranges',
          icon: 'http',
          link: 'jobsipranges',
          raw: 'jobsipranges',
        },
        {
          name: 'IP Ranges Version',
          icon: 'http',
          link: 'jobsiprangesversions',
          raw: 'jobsiprangesversions',
        },
      ],
    },
    {
      name: 'Business Description',
      opened: false,
      active: false,
      children: [
        {
          name: 'Contracts',
          icon: 'edit',
          link: 'contracts',
          raw: 'contracts',
        },
        {
          name: 'Catalogs',
          icon: 'folder_open',
          link: 'catalogs',
          raw: 'catalogs',
        },
        { name: 'SKU', icon: 'qr_code', link: 'skus', raw: 'skus' },
        {
          name: 'Cascade',
          icon: 'shopping_cart',
          link: 'cascades',
          raw: 'cascades',
        },
        { name: 'Fees', icon: 'data_usage', link: 'fees', raw: 'fees' },
      ],
    },
    {
      name: 'Service Definition',
      opened: false,
      active: false,
      children: [
        {
          name: 'Services',
          icon: 'shopping_basket',
          link: 'services',
          raw: 'services',
        },
        {
          name: 'Products',
          icon: 'public',
          link: 'products',
          raw: 'products',
        },
        { name: 'Offers', icon: 'local_offer', link: 'offers', raw: 'offers' },
        { name: 'Packs', icon: 'inventory', link: 'packs', raw: 'packs' },
        {
          name: 'Cappings',
          icon: 'publish',
          link: 'cappings',
          raw: 'cappings',
        },
        {
          name: 'Credit Setup',
          icon: 'credit_card',
          link: 'creditsetups',
          raw: 'creditsetups',
        },
      ],
    },
    // {
    //   name: 'Documents',
    //   opened: false,
    //   active: false,
    //   children: [
    //     {
    //       name: 'Legal Documents',
    //       icon: 'local_police',
    //       link: 'legaldocuments',
    //       raw: 'legaldocuments',
    //     },
    //     {
    //       name: 'Documents Versions',
    //       icon: 'policy',
    //       link: 'legaldocumentversions',
    //       raw: 'legaldocumentversions',
    //     },
    //     {
    //       name: 'Documents Archives',
    //       icon: 'archive',
    //       link: 'legaldocumentversionarchives',
    //       raw: 'legaldocumentversionarchives',
    //     }
    //   ]
    // },
    {
      name: 'Acquisition',
      opened: false,
      active: false,
      children: [
        {
          name: 'Source',
          icon: 'water_drop',
          link: 'acquisitionsources',
          raw: 'acquisitionsources',
        },
        {
          name: 'Account',
          icon: 'fingerprint',
          link: 'acquisitionaccounts',
          raw: 'acquisitionaccounts',
        },
        {
          name: 'Traffic Manager',
          icon: 'person',
          link: 'trafficmanagers',
          raw: 'trafficmanagers',
        },
        {
          name: 'Mapping',
          icon: 'merge',
          link: 'acquisitionmappings',
          raw: 'acquisitionmappings',
        },
      ],
    },
    {
      name: 'Technical Configurations',
      opened: false,
      children: [
        {
          name: 'Billing Policies',
          icon: 'shield',
          link: 'billing-policies',
          raw: 'billingpolicies',
        },
        { name: 'Tags', icon: 'tag', link: 'tags', raw: 'tags' },
        {
          name: 'Platforms',
          icon: 'dns',
          link: 'platforms',
          raw: 'platforms',
        },
        {
          name: 'Notifications',
          icon: 'notifications',
          link: 'notifications',
          raw: 'notificationmanagementsdvp4m',
        },
        {
          name: 'USSD Menus',
          icon: 'list',
          link: 'ussdmenus',
          raw: 'ussdmenus',
        },
      ],
    },
    {
      name: 'Shortcode / Keyword',
      opened: false,
      active: false,
      children: [
        {
          name: 'Shortcode',
          icon: 'dialpad',
          link: 'shortcodes',
          raw: 'shortcodes',
        },
        {
          name: 'Keyword',
          icon: 'abc',
          link: 'keywords',
          raw: 'keywords',
        },
      ],
    },
    {
      name: 'Admin Configurations',
      opened: false,
      active: false,
      children: [
        {
          name: 'Activities',
          icon: 'store',
          link: 'activities',
          raw: 'activities',
        },
        {
          name: 'Billing Channels',
          icon: 'currency_exchange',
          link: 'billingchannels',
          raw: 'billingchannels',
        },
        {
          name: 'Enums',
          icon: 'playlist_add_icon',
          link: 'enums',
          raw: 'enums',
        },
        {
          name: 'Versions',
          icon: 'manage_history_icon',
          link: 'versions',
          raw: 'versions',
        },
      ],
    },
  ];
  menuItemsList: MenuNode[] = [];

  currentRoute: string = '';

  constructor(private router: Router, private auth: AuthService) {
    this.auth.user.subscribe((user) => {
      if (user) {
        this.user = user;
        this.menuItemsList = [];
        this.rawMenuItemsList.map((raw) => {
          const childrens: MenuNode[] = [];
          raw.children!.map((child) => {
            let found = user.permissions.find(
              (elem) => elem === `menu-${child.raw!}`
            );
            if (!!found) {
              childrens.push(child);
            }
          });
          if (childrens.length) {
            raw.children = [...childrens];
            this.menuItemsList.push(raw);
          }
        });
      }
    });
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        const firstChild = event.url.split('/');
        this.currentRoute = firstChild[1];
        this.openSubmenu(this.currentRoute);
      }
    });
  }

  openSubmenu(menu: string): void {
    let itemFound: MenuNode | null = null;
    this.rawMenuItemsList.map((m) => {
      m.opened = false;
      m.active = false;
      if (menu === m.name.toLowerCase()) {
        m.opened = true;
        m.active = true;
        itemFound = m;
      } else {
        m.children?.find((item) => {
          if (item.link === menu) {
            itemFound = m;
            m.opened = true;
            m.active = true;
          }
        });
      }
    });
  }
}
